import { parse } from "papaparse";
import { orderBulkUploadValidations } from "./schemas/order-bulk-upload-validations";
import { getBulkOrderValidation } from "src/services/oms-api";

interface UserDetails {
  user_ucode: string;
  actor_name: string;
  actor_code: string;
  actor_type: string;
}

export const validateOrderBulkFile = async (fileList: FileList, selectedData: any, userDetails: UserDetails): Promise<any | void> => {
  const fileToParse = fileList[0];
  const fileReader = new FileReader();

  return new Promise((resolve, reject) => {
    fileReader.onload = async (e: any) => {
      if (e.target && e.target.result) {
        let parsedResult: any = parse(e.target.result as any, {
          header: true,
          //@ts-ignore
          encoding: "utf-8",
          skipEmptyLines: true,
          dynamicTyping: true,
        });
        let cleanedData = [];

        for (let item of parsedResult.data) {
          let isNull = true;
          for (let key in item) {
            if (item[key] !== null) {
              isNull = false;
              break;
            }
          }
          if (isNull) {
            break;
          } else {
            cleanedData.push(item);
          }
        }

        parsedResult = cleanedData;

        let errors: any[] = [];
        let valid: any[] = [];
        let schemaFields: any[] = [];
        let parsedFields: any[] = [];
        let missingFields: any[] = [];

        const schema = orderBulkUploadValidations(selectedData);
        // check column schema first
        schemaFields = Object.keys(schema.fields);
        parsedFields = Object.keys(parsedResult[0]);
        missingFields = schemaFields.filter((field) => !parsedFields.includes(field));
        if (missingFields.length > 0) {
          return reject([
            {
              success: false,
              message: "Make sure you are entering right template with right column names",
            },
          ]);
        }

        // validate each row
        await Promise.all(
          parsedResult.map(async (row: any) => {
            try {
              await schema.validate(row, { abortEarly: false });
            } catch (validationError) {
              const castedError = validationError as any;
              errors.push({ ...row, message: castedError.errors, success: false });
            }
          })
        );

        if (errors.length > 0) {
          reject(errors);
        } else {
          getBulkOrderValidation(parsedResult)
            .then((res: any) => {
              if (!res || !res.data) {
                return reject([{ success: false, message: "Empty response from server" }]);
              }

              const { success, message, data, errors } = res.data;

              if (success && Array.isArray(data)) {
                const dataWithUser = data.map((item: any) => ({
                  ...item,
                  userDetails: userDetails,
                }));
                valid.push(...dataWithUser);
                return resolve(valid);
              }
              if (!success && Array.isArray(data) && data.length > 0) {

                const formattedErrors = data
                  ?.filter((errMsg: any) => errMsg?.success == false)
                  ?.map((errMsg: any) => ({
                    success: false,
                    company_counter_code: errMsg?.company_counter_code,
                    stockist_code: errMsg?.stockist_code,
                    companyCode: errMsg?.company_code,
                    item_code: errMsg?.item_code,
                    message: errMsg?.message,
                  }));
                return reject(formattedErrors);
              }

              const errorObj = {
                success: false,
                message: message || "Validation failed",
              };
              errors.push(errorObj);
              return reject(errors);
            })
            .catch((err: any) => {
              const backendMessage =
                err?.response?.data?.message ||
                err?.message ||
                "API request failed";
              return reject([{ success: false, message: backendMessage }]);
            });
        }
      }
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
    fileReader.readAsText(fileToParse, "UTF-8");
  });
};
